module.exports = __webpack_public_path__ + "assets/google-cloud-cdn.fe11eb8f.svg";